import React, { useState } from 'react';
import { Table, Button, Input, Select, Popconfirm, Space, Card } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useSelector } from 'react-redux';
import { getSearchPatients } from '../../../network/appointment';
const AccountsList = ({ setDataSource, dataSource, t, form, account }) => {
  const { companyName } = useSelector((state) => state.user);
  const [searchTxtAccount, setSearchTxtAccount] = useState('');
  // const { data: Account } = useQuery({
  //     queryKey: [queryKeys.getSearchAccount],
  //     queryFn: () => getSearchApi('Account'),
  //     keepPreviousData: true,
  //   });
  const { data: Account } = useQuery({
    queryKey: [queryKeys.getSearchAccount, searchTxtAccount],
    queryFn: () => getSearchPatients('Account', searchTxtAccount),
    enabled: searchTxtAccount?.length >= 2 || searchTxtAccount?.length === 0,
    keepPreviousData: true,
  });
  console.log(Account, 'Account');

  const [count, setCount] = useState(0);
  const columns = [
    {
      title: t.Account,
      dataIndex: 'account',
      render: (text, record, index) => (
        <Select
          showSearch
          // placeholder={t.uom}
          placeholder={t.Account}
          style={{ width: '300px' }}
          options={Account?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
          value={record.account}
          filterOption={false}
          onSearch={(value) => {
            setSearchTxtAccount(value);
          }}
          onChange={(value) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              account: value,
            };
            setDataSource(newDataSource);
          }}
        />
      ),
    },
    // {
    //   title: t.company,
    //   dataIndex: 'company',
    //   render: (text, record, index) => (
    //     <Input
    //     placeholder={t.company}
    //     style={{ width: '300px' }}
    //     value={companyName}
    //     disabled
    //   />
    //   ),
    // },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      company: companyName,
      account: account,
    };
    setDataSource((prevDataSource) => [...prevDataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSource.filter((item) => item.key !== key);
    setDataSource(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSource}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};

export default AccountsList;
